import { render } from "./Eiendomsskatt.vue?vue&type=template&id=0855f7bc&scoped=true"
import script from "./Eiendomsskatt.vue?vue&type=script&lang=js"
export * from "./Eiendomsskatt.vue?vue&type=script&lang=js"

import "./Eiendomsskatt.vue?vue&type=style&index=0&id=0855f7bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0855f7bc"]])

export default __exports__